import { TextAreaTemplate } from '@templates';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { RoutesList } from '../../../routes/Routes';
import { useEVChargerStore } from '../../../../hooks/useEVChargerStore';
import { ErrorMessages } from '@types';
import { parseZodErrors, scrollTop } from '@utils';
import { ZodError } from 'zod';

export const TellUsMore = () => {
  const {
    update,
    data: { tellUsMoreDetails, issueType },
  } = useEVChargerStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();
  const MAX_LENGTH = 500;
  const mandatoryAnswer = issueType === 'SomethingElse';
  const pageTitle = mandatoryAnswer
    ? 'Tell us about the issue'
    : 'Tell us more about the issue (optional)';
  const errorPath = 'tellUsMore';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    update('tellUsMoreDetails', event.target.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      setErrorMessages([]);
      try {
        if (mandatoryAnswer && tellUsMoreDetails === '') {
          setErrorMessages([
            {
              path: errorPath,
              message: 'Enter details about the issue.',
            },
          ]);
          return;
        }
        if (tellUsMoreDetails.length > MAX_LENGTH) {
          setErrorMessages([
            {
              path: errorPath,
              message:
                'Details about the issue must be 500 characters or less.',
            },
          ]);
          return;
        }

        update('tellUsMoreDetails', tellUsMoreDetails);
        navigate(RoutesList.EMAIL_CONFIRMATION);
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.ISSUE);
    },
  };

  return (
    <TextAreaTemplate
      initialTextValue={tellUsMoreDetails}
      labelText={pageTitle}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={MAX_LENGTH}
      errorPath={errorPath}
      errorMessages={errorMessages}
    />
  );
};
